import React from 'react';
import { AdminPanelPage } from '../AdminPanelPage';
import { Heading, NumberDisplay } from '@aidkitorg/component-library';

const FAKE_ACCOUNTING_OVERVIEW_DATA = {
  totalBalanceInCents: 55361032,
}


export const AccountsPage = () => {
  const headerContent = (
    <>
      <div>
        <Heading level="h1" className="m-0">Accounts</Heading>
      </div>
    </>
  )

  const totalBalanceCard = <NumberDisplay 
    title="Total Available Balance"
    isCurrency={true}
    locale="en-US"
    currency="USD"
    iconColor='blue'
    iconName='WalletIcon'
    className="max-w-56"
    value={0.01 * FAKE_ACCOUNTING_OVERVIEW_DATA.totalBalanceInCents}
  />

  return (
    <AdminPanelPage
      headerContent={headerContent}
    >
      {totalBalanceCard}
    </AdminPanelPage>
  )
}